(function () {
  "use strict";

  if (window.pmcFooterChatBound) return;
  window.pmcFooterChatBound = true;
  document.documentElement.setAttribute("data-pmc-footer-chat", "ready");

  var fallbackCheckId = 0;

  function isPlainPrimaryClick(event) {
    return !event.defaultPrevented &&
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey;
  }

  function isReamazeUiVisible() {
    var popup = document.querySelector('#reamaze-popup.reamaze-visible');
    var wrapper = popup && popup.querySelector('#reamaze-wrapper');
    if (!wrapper) return false;

    var box = wrapper.getBoundingClientRect();
    var styles = window.getComputedStyle(wrapper);
    return box.width > 0 &&
      box.height > 0 &&
      styles.display !== 'none' &&
      styles.visibility !== 'hidden';
  }

  function verifyOpenOrUseFallback(fallbackHref) {
    var checkId = ++fallbackCheckId;
    var attempts = 0;
    var delays = [150, 350, 700, 1200];

    function verifyOpen() {
      if (checkId !== fallbackCheckId || isReamazeUiVisible()) return;
      if (attempts < delays.length) {
        window.setTimeout(verifyOpen, delays[attempts++]);
        return;
      }
      window.location.href = fallbackHref;
    }

    verifyOpen();
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest &&
      event.target.closest('footer [data-pmc-reamaze-trigger]');
    if (!trigger || !isPlainPrimaryClick(event)) return;

    var popup = window.Reamaze && window.Reamaze.popup;
    if (typeof popup !== "function") return;

    var fallbackHref = trigger.href;
    try {
      popup.call(window.Reamaze);
    } catch (error) {
      return;
    }

    event.preventDefault();
    verifyOpenOrUseFallback(fallbackHref);
  });

  document.addEventListener('click', function (event) {
    var emailTrigger = event.target.closest &&
      event.target.closest('footer a[data-pmc-reamaze-email-trigger][href^="mailto:"]');
    if (!emailTrigger || !isPlainPrimaryClick(event)) return;

    var fallbackHref = emailTrigger.href;

    window.setTimeout(function () {
      if (!event.defaultPrevented) return;
      verifyOpenOrUseFallback(fallbackHref);
    }, 0);
  }, true);
})();
